module.exports = __webpack_public_path__ + "media/components/sessions/new/nemoa-logo-520e1a36aaa01969a4bbb2c3436a0611.png";